export const menu = {
  menu: {
    menu: "Menu",
    challenges: "Tantangan",
    subscription: "Langganan",
    cancelSubscription: "Batalkan langganan",
    downloadPlanPdf: "Unduh rencana dalam PDF",
    downloadingPlanPdf: "Mengunduh...",
    editPlan: "Edit rencana",
    shareBibleJourney: "Bagikan Bible Journey",
    giveFeedback: "Kirim masukan",
    donate: "Donasi",
    logout: "Keluar",
    editReminder: "Edit pengingat",
    configureReminder: "Atur pengingat",
    yourPlan: "Rencana pribadi Anda",
    challengeInvite: "Undangan tantangan:",
    createAChallenge: "Buat tantangan",
    areYouSure: "Apakah Anda yakin?",
    willLostProgress:
      "Anda akan kehilangan akses ke semua tantangan yang dibuat dan para peserta.",
    yesCancel: "Ya, batalkan langganan",
    changedMyMind: "Saya berubah pikiran",
    unsubscribing: "Membatalkan...",
    successfullyUnsubscribed: "Langganan berhasil dibatalkan",
    premiumAccount: "Akun Premium",
    language: "Bahasa",
    reminder: "Pengingat",
    theme: "Tema",
    dark: "Gelap",
    light: "Terang",
    toCancel:
      "Untuk membatalkan langganan, di ponsel buka Pengaturan > nama Anda > Langganan.",
    toCancelAndroid:
      "Untuk membatalkan langganan, buka Google Play > ikon profil > Pembayaran & langganan > Langganan.",
    processStarted: "Proses dimulai",
    dangerArea: "Area Berbahaya",
    weWillGetInTouch:
      "Kami akan menghubungi Anda terkait progres penghapusan akun. Jika yakin, konfirmasi:",
    payAttention:
      "Periksa kotak masuk Anda. Kami akan mengirim email ke",
    yesImSure: "Ya, saya yakin.",
    askAccountRemoval: "Minta penghapusan akun",
  },
};
